module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-05.cb344121.jpg";